export default __webpack_public_path__ + "static/media/imageBannerOnlinePayment.164dd1c6.png";